






















































































































































































import { Component, Mixins, Watch } from "vue-property-decorator";
import _ from "@/boot/lodash";

// Mixins
import TermsAndConditionsInjectorMixin from "@/mixins/termsAndConditionsInjectorMixin";
import HasValidation from "@/mixins/HasValidation";

// Enums/Data
import { DataModules } from "@/store/modules/data";
import { TranslationsTypes } from "@/data/enums/translations";

// Types
import { ITermsAndConditionsForm } from "@/models/termsAndConditions";
import { ITranslation } from "@/models/translations";

@Component({
  components: {
    "terms-translations-grid": () =>
      import(
        "@/components/app/admin/settings/billing/termsAndConditions/termsTranslationsGrid.vue"
      )
  }
})
export default class TermsAndConditionsForm extends Mixins(
  TermsAndConditionsInjectorMixin,
  HasValidation
) {
  // Data

  public form = {} as ITermsAndConditionsForm;
  public initialForm = {} as ITermsAndConditionsForm;
  public isProcessing = false;
  public isUrl = false;

  // Life-cycle methods

  public created() {
    this.initializeForm();
  }

  // Methods

  public initializeForm() {
    const terms = this.termsData?.current?.terms || {};
    this.form = {
      url: terms.url ?? null,
      name: terms.name || "",
      terms: terms.terms || ""
    } as ITermsAndConditionsForm;
    this.initialForm = _.cloneDeep(this.form);
    this.isUrl = !_.isNull(this.form.url);
  }

  public get hasCurrentTerms() {
    return !_.isNil(this.termsData?.current);
  }

  public get isUrlChanged() {
    return (
      this.isUrl !== !_.isNull(_.get(this.termsData, "current.terms.url", null))
    );
  }

  public async validateBeforeSubmit() {
    try {
      if (!(await this.validate()))
        throw this.$t("_sentence.form_is_not_valid");

      this.isProcessing = true;

      await this.$termsAndConditionsMethods.createTermsAndConditions(
        this.formValues
      );
      await this.$termsAndConditionsMethods.reloadData();

      this.initializeForm();

      this.$store.dispatch("toast/show", {
        message: this.$t("_sentence.terms.successfully_updated")
      });
    } catch (error) {
      this.$store.dispatch("api/handleValidationError", {
        error,
        vm: this
      });
    } finally {
      this.isProcessing = false;
    }
  }

  public openTranslateModal(props: Record<string, any>) {
    this.$store.dispatch(
      `data/${DataModules.TRANSLATIONS}/openTranslationsModal`,
      {
        props: {
          objectId: this.termsData?.current?.id,
          objectTypeCode: TranslationsTypes.TERMS_AND_CONDITIONS,
          brandId: this.termsData.brandId,
          fieldType: "text",
          ...props
        }
      }
    );
  }

  // Computed

  public get formIsChanged() {
    return !this.$_.isEqual(this.form, this.initialForm);
  }

  public get formValues() {
    const formValues = this.form;
    if (!this.isUrl) formValues.url = null;
    return formValues;
  }

  public get termsTypes() {
    return [
      {
        value: false,
        label: this.$t("_sentence.terms.enter_markdown")
      },
      {
        value: true,
        label: this.$t("_sentence.terms.link_to_external_resource")
      }
    ];
  }

  public get translationsLanguageIds() {
    return _.map(
      _.filter(
        this.termsData.translations,
        (translation: ITranslation) => !_.isNull(translation.terms)
      ),
      translation => translation.language_id
    );
  }

  @Watch("termsData.current.id")
  public onTermsChange() {
    this.initializeForm();
  }
}
